import React from "react";
import DeleteIcon from "../../../Common/svg/deleteicon";

const Attachments = ({ attach, i, setAttachments, attachments }) => {
  const handleRemove = (id) => {
    const updatedList = attachments.filter((attach) => attach.id !== id);
    setAttachments(updatedList);
  };
 const handleChange = (e) => {
  const { name, value, files } = e.target;

  setAttachments((prev) =>
    prev.map((item) =>
      item.id === attach.id
        ? {
            ...item,
            [name]: name === "file" ? files[0] : value,
          }
        : item
    )
  );
};
  return (
    <div className="row ">
      <div className="col-md-6 ">
        <label htmlFor="" className="form-label">اسم المرفق</label>
        <input
          type="text"
          name="name"
          value={attach.name}
          className="form-control"
          placeholder="أدخل اسم المرفق"
          onChange={handleChange}
        />
      </div>
      <div className="col-md-4">
        <label htmlFor="" className="form-label"  >المرفق</label>
        <input type="file" className="form-control" onChange={handleChange} name="file"/>
              {attach.url && <img src={attach.url} width={40} height={40}/>}
      </div>

      {i === 0 ? null : (
        <div className="col d-flex align-items-end">
          <button className="btn " onClick={() => handleRemove(attach.id)}>
            <DeleteIcon />
          </button>
        </div>
      )}
    </div>
  );
};

export default Attachments;
